import { ref } from "vue";

import { isTauri } from "./useTauri";

const updateAvailable = ref(false);
// Идёт загрузка/установка — кнопка баннера блокируется.
const updating = ref(false);
const updateError = ref<string | null>(null);
let pendingUpdate: { downloadAndInstall: () => Promise<void> } | null = null;

export async function checkForUpdates(): Promise<void> {
    if (!isTauri) {
        return;
    }
    try {
        const { check } = await import("@tauri-apps/plugin-updater");
        const update = await check();
        if (update?.available) {
            pendingUpdate = update;
            updateAvailable.value = true;
        }
    } catch {
        // ignore — no network or no endpoint configured
    }
}

export async function installUpdate(): Promise<void> {
    if (!pendingUpdate || updating.value) {
        return;
    }
    updating.value = true;
    updateError.value = null;
    try {
        await pendingUpdate.downloadAndInstall();
        // Windows: установщик сам гасит и перезапускает приложение. macOS/Linux
        // после установки НЕ перезапускаются — без relaunch() «ничего не
        // происходит» и юзер сидит на старой версии до ручного рестарта.
        const { relaunch } = await import("@tauri-apps/plugin-process");
        await relaunch();
    } catch (e) {
        console.error("[updater] install failed:", e);
        // Текст причины — прямо на баннер: в релизной сборке консоль
        // недоступна, а без причины ошибку не диагностировать.
        const detail = e instanceof Error ? e.message : String(e);
        updateError.value = `Не удалось обновиться: ${detail}`;
        updating.value = false;
    }
}

export function useUpdater() {
    return { updateAvailable, updating, updateError, installUpdate };
}
